import { Input } from 'components'
import { normalizeNumber } from 'utils'
import { analyticsContext } from 'contexts'

import './styles.scss'

interface Props {
  value: number
  step?: number
  onChange: (value: string | number) => void
  scrollToOnFocus?: boolean
}

const maxValue = 999

export const Volume = (props: Props) => {
  const { value, step = 1, onChange, scrollToOnFocus } = props

  const onSubtract = () => {
    const newValue = value - step

    if (newValue < 0) {
      return
    }

    analyticsContext.trackEvent('volume_changed', { type: 'MINUS' })
    onChange(newValue)
  }

  const onAdd = () => {
    const newValue = +value + step

    if (newValue > maxValue) {
      return
    }

    analyticsContext.trackEvent('volume_changed', { type: 'PLUS' })
    onChange(newValue)
  }

  const onChangeHandler = (value: number) => {
    if (value > maxValue || value < 0) {
      return
    }

    const val = normalizeNumber(value)
    onChange(val)
  }

  return (
    <div className="volume-wrapper">
      <div className="input-label">Количество, мл</div>
      <div className="input-wrapper">
        <button className="volume-button" disabled={value <= 0} onClick={onSubtract}>
          -
        </button>
        <Input
          inputMode="numeric"
          className="form-input volume-input"
          value={value}
          onChange={onChangeHandler}
          scrollToOnFocus={scrollToOnFocus}
          selectOnFocus
        />
        <button className="volume-button" disabled={value >= maxValue} onClick={onAdd}>
          +
        </button>
      </div>
    </div>
  )
}
